import VideoIndicationIcon from "../../../uikit/VideoIndicationIcon";
import { useEnrichmentCardContext } from "../../../pages/DataPage/CardsView/DataList/EnrichmentCard/EnrichmentCardProvider";
import { FrameTimestamp } from "../../../uikit/FrameTimestamp/FrameTimestamp";

export const FrameIndication = ({ timestamp }: { timestamp: number }) => {
  const { isSingleItem } = useEnrichmentCardContext();
  return (
    <>
      {!isSingleItem && <VideoIndicationIcon small />}
      <FrameTimestamp timestamp={timestamp} small={!isSingleItem} />
    </>
  );
};
